<!-- ListGroups Copyright 2022 Rebecca L Beaudet -->
<script lang="ts">
  import { Link } from 'svelte-routing';

  import type { listItem } from '../../language/interface';

  export let listGroup: { heading: string; group: listItem[] };
  export let size: number = 3;
</script>

{#if listGroup.group.length}
  <div class={`col-md-${size}`}>
    <h4>{listGroup.heading}</h4>
    <ul class={`list-group`} id="listGroups">
      {#each listGroup.group as item, i}
        {#if item?.path}
          <Link class="list-group-item list-group-item-action" to={item.path}>
            {item.title}
          </Link>
        {:else if item?.link}
          <a href={item.link} class="list-group-item list-group-item-action">
            {item.title}
          </a>
        {:else}
          <li class="list-group-item">
            {item.title}
          </li>
        {/if}
      {/each}
    </ul>
  </div>
{/if}
